import { render, staticRenderFns } from "./display-field-link.vue?vue&type=template&id=3899d883&scoped=true&"
import script from "./display-field-link.ts?vue&type=script&lang=ts&"
export * from "./display-field-link.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-link.scss?vue&type=style&index=0&id=3899d883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3899d883",
  null
  
)

export default component.exports